import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgResource = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3333 20C12.4129 20 11.6667 20.7462 11.6667 21.6666C11.6667 22.5871 12.4129 23.3333 13.3333 23.3333H26.6667C27.5871 23.3333 28.3333 22.5871 28.3333 21.6666C28.3333 20.7462 27.5871 20 26.6667 20H13.3333Z",
			fill: "#5E70E2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.6667 28.3333C11.6667 27.4128 12.4129 26.6666 13.3333 26.6666H26.6667C27.5871 26.6666 28.3333 27.4128 28.3333 28.3333C28.3333 29.2538 27.5871 30 26.6667 30H13.3333C12.4129 30 11.6667 29.2538 11.6667 28.3333Z",
			fill: "#5E70E2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3333 13.3333C12.4129 13.3333 11.6667 14.0795 11.6667 15C11.6667 15.9204 12.4129 16.6666 13.3333 16.6666H16.6667C17.5871 16.6666 18.3333 15.9204 18.3333 15C18.3333 14.0795 17.5871 13.3333 16.6667 13.3333H13.3333Z",
			fill: "#5E70E2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.46447 3.13109C7.40215 2.19341 8.67392 1.66663 10 1.66663H23.3333C23.7754 1.66663 24.1993 1.84222 24.5118 2.15478L34.5104 12.1533C34.8128 12.455 35 12.8723 35 13.3333V33.3333C35 34.6594 34.4732 35.9312 33.5355 36.8688C32.5979 37.8065 31.3261 38.3333 30 38.3333H10C8.67392 38.3333 7.40215 37.8065 6.46447 36.8688C5.52678 35.9311 5 34.6594 5 33.3333V6.66663C5 5.34054 5.52678 4.06877 6.46447 3.13109ZM10 4.99996H21.6667V13.3333C21.6667 14.2538 22.4129 15 23.3333 15H31.6667V33.3333C31.6667 33.7753 31.4911 34.1992 31.1785 34.5118C30.8659 34.8244 30.442 35 30 35H10C9.55797 35 9.13405 34.8244 8.82149 34.5118C8.50893 34.1992 8.33333 33.7753 8.33333 33.3333V6.66663C8.33333 6.2246 8.50893 5.80068 8.82149 5.48812C9.13405 5.17555 9.55797 4.99996 10 4.99996ZM25 7.35698L29.3096 11.6666H25V7.35698Z",
			fill: "#5E70E2"
		})
	]
});
export default SvgResource;
